var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab2-box"},[_c('videoItem',{attrs:{"user":_vm.tab2User,"tab2CurrentShare":_vm.tab2CurrentShare,"idPix":"tab2-video"},on:{"dobClick":_vm.dobuleTab2Click}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }